/**
 * Turn any thrown value into one short Finnish line for the UI.
 */

import { APIError } from './api';

export function errorMessage(err: unknown, fallback = 'Jokin meni pieleen.'): string {
    if (err instanceof APIError) {
        if (err.status === 0) return 'Ei yhteyttä palvelimeen.';
        if (err.status === 408) return 'Palvelin ei vastannut ajoissa.';
        if (err.status === 404) return 'Tietoja ei löytynyt.';
        if (err.status === 400) return err.message || 'Virheellinen pyyntö.';
        if (err.status >= 500) return 'Palvelimella tapahtui virhe.';
        return err.message || fallback;
    }
    if (err instanceof Error && err.message) return err.message;
    return fallback;
}
